import { render, staticRenderFns } from "./ProductSafety.vue?vue&type=template&id=081312b5&scoped=true"
import script from "./ProductSafety.vue?vue&type=script&lang=js"
export * from "./ProductSafety.vue?vue&type=script&lang=js"
import style0 from "./ProductSafety.vue?vue&type=style&index=0&id=081312b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081312b5",
  null
  
)

export default component.exports